<template>
    <div class="menu-wrapper">
        <div class="overflow-container">
            <div class="menu">
                <div v-if="!noEdit" class="menu-item add" @click="open">
                    <i class="el-icon-plus">添加分类</i>
                </div>
                <div class="menu-item all" @click="handleAllClick" :class="{ active: currentNodeKey === 'all' }">
                    <span>全部</span>
                </div>
                <el-tree v-if="!loading" :data="menu" node-key="_id" :current-node-key="currentNodeKey" :props="defaultProps" accordion
                    :highlight-current="true" @node-click="handleNodeClick">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label.length > 15 ? node.label.substring(0, 15) + '...' : node.label }}</span>
                        <span v-if="!noEdit">
                            <el-dropdown trigger="hover" @command="handleCommand">
                                <div class="more">
                                    <i class="el-icon-more"></i>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="!data.parentId"
                                        :command="{ type: 'add', data: data }">添加子分类</el-dropdown-item>
                                    <el-dropdown-item :command="{ type: 'rename', data: data }">重命名</el-dropdown-item>
                                    <el-dropdown-item :command="{ type: 'del', data: data }">删除</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                    </span>
                </el-tree>
            </div>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" width="25%">
            <el-form :model="form" ref="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
                <el-form-item label="分类名称" prop="name">
                    <el-input v-model="form.name" size="small"></el-input>
                </el-form-item>
                <el-form-item label="简介" prop="description">
                    <el-input v-model="form.description" size="small"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getSiteSortList, saveSiteSortType, delSiteSortType } from "@/api/material";

export default {

    props: {
        noEdit: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isInit: false,
            loading: true,
            menu: [],
            currentNodeKey: null,
            dialogVisible: false,
            dialogTitle: "添加分类",
            form: {
                _id: void 0,
                name: "",
                description: "",
                parentId: void 0,
            },
            rules: {
                name: [
                    { required: true, message: '请输入分类名称', trigger: 'blur' },
                ],
            },
            defaultProps: {
                children: "child",
                label: "name",
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        handleNodeClick(data) {
            this.currentNodeKey = data._id;

            const isFirstLevel = !data.parentId
            const param = {
                id: isFirstLevel ? data._id : data.parentId,
                cid: isFirstLevel ? void 0 : data.id,
            }
            this.$emit("onChangeMenu", param);
        },
        async getList() {
            this.loading = true;
            try {
                const { status, data, message } = await getSiteSortList({
                    page: 1,
                    pageSize: 100,
                });
                if (status == 10000) {
                    // 确保 data.categories 存在且是数组格式
                    if (data && data.categories && Array.isArray(data.categories)) {
                        this.menu = data.categories;
                        if (!this.isInit) {
                            this.isInit = true
                            // 默认选中"全部"选项
                            this.handleAllClick();
                        }
                        this.menu = this.menu.map((item) => {
                            let result = {
                                checked: false,
                                ...item
                            };
                            if (item.child && item.child.length) {
                                result.child = item.child.map(childItem => ({
                                    checked: false,
                                    ...childItem
                                }));
                            }
                            return result;
                        });
                    } else {
                        console.warn('分类列表数据格式异常:', data);
                        this.menu = [];
                        this.$message.warning('分类列表数据格式异常，请检查后端服务');
                    }
                } else {
                    this.$message.error(message || '获取分类列表失败');
                    this.menu = [];
                }
            } catch (error) {
                console.error('获取分类列表失败:', error);
                this.$message.error('获取分类列表失败，请检查网络连接或后端服务');
                this.menu = [];
            } finally {
                this.loading = false;
            }
        },

        open(data) {
            this.dialogTitle = data?._id ? "编辑分类" : "添加分类";
            const isFirstLevel = !data.parentId; // 有id 表示是二级列表
            this.form = {
                id: isFirstLevel ? data._id : data.parentId,
                cid: isFirstLevel ? void 0 : data.id,
                name: data.name,
                description: data.description,
            };
            this.dialogVisible = true;
        },

        subOpen(data) {
            this.dialogTitle = "添加分类";
            this.form = {
                parentId: data._id,
                name: '',
                description: '',
            };
            this.dialogVisible = true;
        },
        save(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const isAdd = this.form.id == null;
                    const { status, message } = await saveSiteSortType(isAdd, this.form);
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message,
                        });
                        this.getList();
                        this.dialogVisible = false;
                    } else {
                        this.$message.error(message);
                    }
                }
            });

        },

        del(data) {
            this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const isFirstLevel = !data.parentId; // 有id 表示是二级列表
                    const { status, message } = await delSiteSortType({
                        id: isFirstLevel ? data._id : data.parentId,
                        cid: isFirstLevel ? void 0 : data.id,
                    });
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getList();
                    } else {
                        this.$message.error(message);
                    }
                })
                .catch(() => {
                    console.info("已取消删除!");
                });
        },
        handleCommand({ type: command, data }) {
            if (command === "rename") {
                this.open(data);
            } else if (command === "del") {
                this.del(data);
            } else if (command === "add") {
                this.subOpen(data);
            }
        },

        changeTab(id) {
            this.$emit("getList", id);
        },

        handleAllClick() {
            this.currentNodeKey = 'all';
            this.$emit("onChangeMenu", { id: void 0, cid: void 0 });
        },
    },
};
</script>
<style lang="scss" scoped>
.menu-wrapper {
    .overflow-container {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);

        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 8px;

    > span:first-child {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 8px;
    }

    .more {
        flex-shrink: 0;
        cursor: pointer;
        padding: 4px;
        
        &:hover {
            color: #409EFF;
        }
    }
}

::v-deep .el-tree-node__content {
    height: 42px;
    font-size: 14px;

}

::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    color: #2061e6;
}

.menu {
    width: 300px;
    height: 100%;
}

.menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 42px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        span {
            color: #2061e6;
        }
    }

    span {
        color: #333333;
    }

    .more {
        font-size: 12px;
        color: #666666;
        transform: rotate(0.25turn);
    }

    &.add {
        color: #2061e6;
    }
    
    &.all {
        color: #333333;
        border-bottom: 1px solid #f0f0f0;
        
        &:hover {
            background-color: #f5f7fa;
        }
    }
}

.menu-item.active {
    background-color: #f0f7ff;

    span {
        color: #2061e6;
    }
}
</style> 